import React, { useState } from 'react'

import Icon from 'src/common/components/icon'
import Tooltip from 'src/common/components/tooltip'


const Title = ({customTitle}) => {
  const [showTooltip, setShowTooltip] = useState(false)
  return (
    <div className='offers-title'>
      <span>{customTitle}</span>
      <Tooltip
        dataAutoId='offerInfoIcon'
        category='primary'
        message='We chose these offers just for you based on your shopping history'
        show={showTooltip}
        closeHandler={() => setShowTooltip(false)}
        isAdvanced
        className="offers-title__tooltip"
      >
        <Icon onClickHandler={() => setShowTooltip(!showTooltip)} name='info' />
      </Tooltip>
    </div>
  )
}

export default Title



// WEBPACK FOOTER //
// ./components/personalizedRecommendation/title.js